import GTM_EVENTS from "../gtm/gtmevents";
import { DOCUMENT_LABELS } from "./common";

export const TOOLPANE_TTITLE = {
  DOC_COMPONENTS: "doc-components",
  NOTES: "notes",
  METAFIELD: "meta-field",
  COLLABORATORS: "collaborators",
  CATALOG: "catalog",
  DOCUMENT_DETAILS: "document-details",
  TEMPLATE_DETAILS: "template-details",
  DYNAMIC_FIELDS: "dynamic-fields",
  ACTIVITY: "activity",
  GOOGLE_CATALOG: "google-catalog",
  EXCEL_CATALOG: "excel-catalog",
  ATTACHMENTS: "attachments",
  QUICK_REVIEW: "quick-review",
  SIGNATURE_COMPONENTS: "signature-components",
  SETTINGS: "settings",
  DOC_SIGNATURE_COMPONENTS: "doc-signature-components",
  SIGN_TAG_PROPERTIES: "sign-tag-properties",
};

/**
 * * Do not change the order inside the array, coz in UI
 * * they have to be displayed in same order.
 */
export const TOOLPANE_OPTIONS = {
  DOCUMENT: [
    {
      title: "doc-components",
      ico: "puzzle-piece",
      toolTipLabel: `${DOCUMENT_LABELS["component-label"]}`,
      gtmAction: GTM_EVENTS.DOCUMENTVIEW_BLOCKS_PANE_OPEN,
    },
    {
      title: "doc-signature-components",
      ico: "signature",
      toolTipLabel: `Signature`,
      hasNewTag: false,
      gtmAction: GTM_EVENTS.DOCUMENTVIEW_SIGN_PANE_OPEN,
    },
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
      gtmAction: GTM_EVENTS.DOCUMENTVIEW_NOTES_PANE_OPEN,
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
      gtmAction: GTM_EVENTS.DOCUMENTVIEW_ATTACHMENT_PANE_OPEN,
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
      gtmAction: GTM_EVENTS.DOCUMENTVIEW_COLLABORATORS_PANE_OPEN,
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
      gtmAction: GTM_EVENTS.DOCUMENTVIEW_ACTIVITY_PANE_OPEN,
    },
    {
      title: "meta-field",
      ico: "square-m",
      iconType: "fas",
      toolTipLabel: "Metadata",
      hasNewTag: true,
      hasToolTip: true,
      toolTipMessage:
        "See details of this document and create Meta fields here",
      gtmAction: GTM_EVENTS.DOCUMENTVIEW_METAFIELD_PANE_OPEN,
    },
    // {
    //   title: "document-details",
    //   ico: "info-circle",
    //   toolTipLabel: "Details",
    // },
    // {
    //   title: "quick-review",
    //   ico: "microscope",
    //   toolTipLabel: "Metalens",
    // },
    {
      title: "settings",
      ico: "cog",
      toolTipLabel: "Settings",
      gtmAction: GTM_EVENTS.DOCUMENTVIEW_SETTINGS_PANE_OPEN,
    },
  ],
  DEAL_TABLE: [
    {
      title: "catalog",
      ico: "clipboard-list-check",
      toolTipLabel: "Catalog",
      hideOnViewMode: true,
    },
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
  ],
  GOOGLE_SHEET: [
    {
      title: "google-catalog",
      ico: "clipboard-list-check",
      toolTipLabel: "Google Sheet",
      hideOnViewMode: true,
    },
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
  ],
  QUOTE_TABLE: [
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
  ],
  EXCEL_TABLE: [
    {
      title: "excel-catalog",
      ico: "clipboard-list-check",
      toolTipLabel: "Uploaded excel",
      hideOnViewMode: true,
    },
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
  ],
  TEMPLATE: [
    {
      title: "doc-components",
      ico: "puzzle-piece",
      toolTipLabel: `${DOCUMENT_LABELS["component-label"]}`,
      gtmAction: GTM_EVENTS.TEMPLATEVIEW_BLOCKS_PANE_OPEN,
    },
    {
      title: "doc-signature-components",
      ico: "signature",
      toolTipLabel: `Signature`,
      hasNewTag: false,
      gtmAction: GTM_EVENTS.TEMPLATEVIEW_SIGN_PANE_OPEN,
    },
    {
      title: "dynamic-fields",
      ico: "brackets",
      toolTipLabel: `${DOCUMENT_LABELS["dynamic-label"]} Fields`,
      gtmAction: GTM_EVENTS.TEMPLATEVIEW_FORMFIELDS_PANE_OPEN,
    },
    {
      title: "meta-field",
      ico: "square-m",
      iconType: "fas",
      toolTipLabel: "Metadata",
      hasNewTag: true,
      hasToolTip: true,
      toolTipMessage:
        "See details of this template and create Meta fields here",
      gtmAction: GTM_EVENTS.TEMPLATEVIEW_METADATA_PANE_OPEN,
    },
    {
      title: "settings",
      ico: "cog",
      toolTipLabel: "Settings",
      gtmAction: GTM_EVENTS.TEMPLATEVIEW_SETTINGS_PANE_OPEN,
    },
  ],
  PDF_TEMPLATE: [
    {
      title: "signature-components",
      ico: "signature",
      toolTipLabel: `Signature`,
    },
    {
      title: "meta-field",
      ico: "square-m",
      iconType: "fas",
      toolTipLabel: "Metadata",
      hasNewTag: true,
      hasToolTip: true,
      toolTipMessage:
        "See details of this template and create Meta fields here",
    },
  ],
  PDF_DOCUMENT: [
    {
      title: "signature-components",
      ico: "signature",
      toolTipLabel: `Signature`,
    },
    {
      title: "notes",
      ico: "comments-alt",
      toolTipLabel: "Notes",
    },
    {
      title: "attachments",
      ico: "paperclip",
      toolTipLabel: "Attachments",
    },
    {
      title: "collaborators",
      ico: "users",
      toolTipLabel: "Team",
    },
    {
      title: "activity",
      ico: "heart-rate",
      toolTipLabel: "Activity",
    },
    {
      title: "document-details",
      ico: "info-circle",
      toolTipLabel: "Details",
    },
    {
      title: "meta-field",
      ico: "square-m",
      iconType: "fas",
      toolTipLabel: "Metadata",
      hasNewTag: true,
      hasToolTip: true,
      toolTipMessage:
        "See details of this document and create Meta fields here",
    },
    {
      title: "quick-review",
      ico: "microscope",
      toolTipLabel: "Metalens",
    },
    {
      title: "settings",
      ico: "cog",
      toolTipLabel: "Settings",
    },
  ],
};

export const TOOLPANE_OPTIONS_FREE = {
  DOCUMENT: [
    {
      title: "doc-components",
      ico: "puzzle-piece",
      toolTipLabel: `${DOCUMENT_LABELS["component-label"]}`,
    },
    {
      title: "doc-signature-components",
      ico: "signature",
      toolTipLabel: `Signature`,
      hasNewTag: false,
    },
    {
      title: "document-details",
      ico: "info-circle",
      iconType: "fas",
      hasToolTip: true,
      toolTipLabel: `Details`,
      toolTipMessage: "See details of this document",
    },
  ],
  QUOTE_TABLE: [
    {
      title: "document-details",
      ico: "info-circle",
      iconType: "fas",
      hasToolTip: true,
      toolTipLabel: `Details`,
      toolTipMessage: "See details of this document",
    },
  ],
  DEAL_TABLE: [
    {
      title: "document-details",
      ico: "info-circle",
      iconType: "fas",
      hasToolTip: true,
      toolTipLabel: `Details`,
      toolTipMessage: "See details of this document",
    },
  ],
  TEMPLATE: [
    {
      title: "doc-components",
      ico: "puzzle-piece",
      toolTipLabel: `${DOCUMENT_LABELS["component-label"]}`,
    },
    {
      title: "doc-signature-components",
      ico: "signature",
      toolTipLabel: `Signature`,
      hasNewTag: false,
    },
    {
      title: "dynamic-fields",
      ico: "brackets",
      toolTipLabel: `${DOCUMENT_LABELS["dynamic-label"]} Fields`,
    },
    {
      title: "template-details",
      ico: "info-circle",
      iconType: "fas",
      hasToolTip: true,
      toolTipLabel: `Details`,
      toolTipMessage: "See details of this template",
    },
  ],
  PDF_DOCUMENT: [
    {
      title: "signature-components",
      ico: "signature",
      toolTipLabel: `Signature`,
    },
    {
      title: "document-details",
      ico: "info-circle",
      iconType: "fas",
      hasToolTip: true,
      toolTipLabel: `Details`,
      toolTipMessage: "See details of this document",
    },
  ],
  EXCEL_TABLE: [
    {
      title: "document-details",
      ico: "info-circle",
      iconType: "fas",
      hasToolTip: true,
      toolTipLabel: `Details`,
      toolTipMessage: "See details of this document",
    },
  ],
  GOOGLE_SHEET: [
    {
      title: "document-details",
      ico: "info-circle",
      iconType: "fas",
      hasToolTip: true,
      toolTipLabel: `Details`,
      toolTipMessage: "See details of this document",
    },
  ],
  PDF_TEMPLATE: [
    {
      title: "signature-components",
      ico: "signature",
      toolTipLabel: `Signature`,
    },
  ],
};
